import { render, staticRenderFns } from "./DismantleInvoice.vue?vue&type=template&id=7f037470&scoped=true"
import script from "./DismantleInvoice.vue?vue&type=script&lang=ts"
export * from "./DismantleInvoice.vue?vue&type=script&lang=ts"
import style0 from "./DismantleInvoice.vue?vue&type=style&index=0&id=7f037470&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f037470",
  null
  
)

export default component.exports